module.exports = __webpack_public_path__ + "static/media/3.0d3b3b7e.png";